import { AppRoute } from '../enums/appRoutes';
import { CheckoutPage } from '../pages/CheckoutPage/CheckoutPage';
import { ConfirmationPage } from '../pages/ConfirmationPage/ConfirmationPage';
import { ErrorPage } from '../pages/ErrorPage';
import { QuotePageA } from '../pages/QuotePage/QuotePageA';

export const additionalRoutes = [
  {
    path: AppRoute.QUOTE,
    element: <QuotePageA />,
    title: 'Your Quote',
  },
  {
    path: AppRoute.CONFIRMATION,
    element: <ConfirmationPage />,
    title: 'Confirmation',
  },
  {
    path: AppRoute.CHECKOUT,
    element: <CheckoutPage />,
    title: 'Checkout',
  },
  {
    path: AppRoute.ERROR,
    element: <ErrorPage />,
    title: 'Error',
  },
];
